import { useEffect, useState } from 'react';
import {
  getGenreGameList,
  getSelectorConfig,
} from '@/pages/benchmark/services/benchmark';
import { FRAME_TYPE_MAP } from '@/pages/benchmark/_config/constant';

export interface IFilterOption {
  code: string;
  name_ch: string;
  name_en: string;
}

export interface IMetricFilter {
  name: string;
  value: string[];
}

export interface IMetricFilterOption {
  metric: string;
  metric_ch: string;
  metric_en: string;
  category: string;
  category_ch: string;
  category_en: string;
  filter: IMetricFilter[];
}

export interface IOptionMap {
  [key: string]: IFilterOption;
}

const useData = (frameType: string) => {
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const [countryOptions, setCountryOptions] = useState<IFilterOption[]>([]);
  const [countryMap, setCountryMap] = useState<IOptionMap>({});

  const [platformOptions, setPlatformOptions] = useState<IFilterOption[]>([]);
  const [platformMap, setPlatformMap] = useState<IOptionMap>({});

  const [genreOptions, setGenreOptions] = useState<IFilterOption[]>([]);

  const [metricOptions, setMetricOptions] = useState<IMetricFilterOption[]>([]);

  const [gameOptions, setGameOptions] = useState<any[]>([]);

  const [currentType, setCurrentType] = useState('genre');

  useEffect(() => {
    setLoading(true);
    const newParams = new URLSearchParams(window.location.search);
    // 首页跳转过来
    const game = newParams.get('game');
    // 详情页返回
    const type = newParams.get('type');
    if (game) {
      setCurrentType(game ? 'game' : 'genre');
    } else if (type) {
      setCurrentType(type === 'game' ? 'game' : 'genre');
    }

    getSelectorConfig({
      frame_type: FRAME_TYPE_MAP[frameType],
      // 这里无需加载品类游戏选项
      genre_selector_type: 'genre',
    })
      .then((data) => {
        const { metric_list, selector } = data;
        const { country_list, genre_list, platform_list } = selector || {};

        // 国家,all固定在第一选项
        const noAllCountrys = country_list?.filter(
          (item: IFilterOption) => item?.code?.toLocaleLowerCase() !== 'global',
        );
        const allCountry = country_list?.filter(
          (item: IFilterOption) => item?.code?.toLocaleLowerCase() === 'global',
        );

        const newCountryMap = country_list?.reduce(
          (t: IOptionMap, curr: IFilterOption) => {
            t[curr.code] = curr;
            return t;
          },
          {},
        );

        const newPlatformMap = platform_list?.reduce(
          (t: IOptionMap, curr: IFilterOption) => {
            t[curr.code] = curr;
            return t;
          },
          {},
        );

        // 品类增加全部选项
        genre_list.unshift({ code: "255", name_ch: "全部", name_en: "All" });

        setCountryMap(newCountryMap);
        setPlatformMap(newPlatformMap);
        setMetricOptions(metric_list);
        setGenreOptions(genre_list);
        setPlatformOptions(platform_list);
        setCountryOptions([...allCountry, ...noAllCountrys]);

        // 首页品类跳转
        if (game) {
          getGenreGameList({
            genre_code: game,
            genre_category: 'game',
            game_id: [],
            frame_type: FRAME_TYPE_MAP[frameType],
          })
            .then((data) => {
              setGameOptions(data.game_ids);
            })
            .finally(() => setLoading(false));
        } else {
          // 读取上一次缓存
          try {
            const gameListJson =
              localStorage.getItem(
                `__dbb_${frameType}_benchmark_filter_game_list__`,
              ) || '[]';
            setGameOptions(JSON.parse(gameListJson) || []);
          } catch (error) {}
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log('🚀 ~ 筛选器接口 ~ 错误:', err);
        setIsError(true);
        setLoading(false);
      });
  }, []);

  return {
    currentType,
    gameOptions,
    genreOptions,
    platformOptions,
    platformMap,
    countryOptions,
    countryMap,
    metricOptions,
    loading,
    isError,
    frameType: FRAME_TYPE_MAP[frameType],
    setCurrentType,
    setGameOptions,
  };
};

export default useData;
